/* NOTE: Override the old styles for now */
.item {
  background-position: left top !important;
}

.info {
  font-size: 13px;
  line-height: 1rem;
}
